(function (window, document) {
  "use strict";

  var DNB = window.DNB;

  document.addEventListener("DOMContentLoaded", function () {
    DNB.safeInit("CareerUpload", function () { DNB.CareerUpload.init(); });
    DNB.safeInit("CareerForm", function () { DNB.CareerForm.init(); });
    DNB.safeInit("CareerBoards", function () { DNB.CareerBoards.init(); });
  });
})(window, document);
